import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Highlights.css';

function renderHighlightIcon(iconName) {
  const normalized = (iconName || 'globe').toLowerCase().trim();

  let pathContent;
  switch (normalized) {
    case 'shield':
    case 'security':
    case 'lock':
      pathContent = (
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" strokeLinecap="round" strokeLinejoin="round"></path>
      );
      break;
    case 'trending-down':
    case 'ticket':
    case 'support':
      pathContent = (
        <>
          <polyline points="23 18 13.5 8.5 8.5 13.5 1 6" strokeLinecap="round" strokeLinejoin="round"></polyline>
          <polyline points="17 18 23 18 23 12" strokeLinecap="round" strokeLinejoin="round"></polyline>
        </>
      );
      break;
    case 'trending-up':
    case 'growth':
    case 'chart':
      pathContent = (
        <>
          <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" strokeLinecap="round" strokeLinejoin="round"></polyline>
          <polyline points="17 6 23 6 23 12" strokeLinecap="round" strokeLinejoin="round"></polyline>
        </>
      );
      break;
    case 'heart':
    case 'retention':
      pathContent = (
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l8.78-8.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" strokeLinecap="round" strokeLinejoin="round"></path>
      );
      break;
    case 'star':
    case 'award':
      pathContent = (
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" strokeLinecap="round" strokeLinejoin="round"></polygon>
      );
      break;
    case 'zap':
    case 'flash':
    case 'speed':
      pathContent = (
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" strokeLinecap="round" strokeLinejoin="round"></polygon>
      );
      break;
    case 'clock':
    case 'timer':
    case 'efficiency':
      pathContent = (
        <>
          <circle cx="12" cy="12" r="9"></circle>
          <polyline points="12 7 12 12 15 14" strokeLinecap="round" strokeLinejoin="round"></polyline>
        </>
      );
      break;
    case 'cpu':
    case 'terminal':
    case 'telemetry':
      pathContent = (
        <>
          <rect x="4" y="4" width="16" height="16" rx="2"></rect>
          <rect x="9" y="9" width="6" height="6"></rect>
          <line x1="9" y1="1" x2="9" y2="4"></line>
          <line x1="15" y1="1" x2="15" y2="4"></line>
          <line x1="9" y1="20" x2="9" y2="23"></line>
          <line x1="15" y1="20" x2="15" y2="23"></line>
          <line x1="20" y1="9" x2="23" y2="9"></line>
          <line x1="20" y1="15" x2="23" y2="15"></line>
          <line x1="1" y1="9" x2="4" y2="9"></line>
          <line x1="1" y1="15" x2="4" y2="15"></line>
        </>
      );
      break;
    case 'rocket':
    case 'performance':
    case 'speedometer':
    case 'gauge':
      pathContent = (
        <>
          <path d="M12 14l4.5-4.5" strokeLinecap="round" strokeLinejoin="round"></path>
          <path d="M3.34 19a10 10 0 1 1 17.32 0" strokeLinecap="round" strokeLinejoin="round"></path>
          <circle cx="12" cy="14" r="1.5" fill="#1a1a1a"></circle>
        </>
      );
      break;
    case 'bookmark':
      pathContent = (
        <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" strokeLinecap="round" strokeLinejoin="round"></path>
      );
      break;
    case 'layout':
    case 'browser':
      pathContent = (
        <>
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="3" y1="9" x2="21" y2="9"></line>
          <line x1="9" y1="21" x2="9" y2="9"></line>
        </>
      );
      break;
    case 'shopping-bag':
    case 'e-commerce':
    case 'cart':
      pathContent = (
        <>
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" strokeLinecap="round" strokeLinejoin="round"></path>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <path d="M16 10a4 4 0 0 1-8 0" strokeLinecap="round" strokeLinejoin="round"></path>
        </>
      );
      break;
    case 'search':
    case 'discovery':
      pathContent = (
        <>
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65" strokeLinecap="round"></line>
        </>
      );
      break;
    case 'sliders':
    case 'filter':
      pathContent = (
        <>
          <line x1="4" y1="21" x2="4" y2="14"></line>
          <line x1="4" y1="10" x2="4" y2="3"></line>
          <line x1="12" y1="21" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12" y2="3"></line>
          <line x1="20" y1="21" x2="20" y2="16"></line>
          <line x1="20" y1="12" x2="20" y2="3"></line>
          <line x1="1" y1="14" x2="7" y2="14"></line>
          <line x1="9" y1="8" x2="15" y2="8"></line>
          <line x1="17" y1="16" x2="23" y2="16"></line>
        </>
      );
      break;
    case 'smartphone':
    case 'mobile':
      pathContent = (
        <>
          <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
          <line x1="12" y1="18" x2="12.01" y2="18" strokeWidth="2.5" strokeLinecap="round"></line>
        </>
      );
      break;
    case 'compass':
    case 'storytelling':
      pathContent = (
        <>
          <circle cx="12" cy="12" r="10"></circle>
          <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" strokeLinecap="round" strokeLinejoin="round"></polygon>
        </>
      );
      break;
    case 'settings':
    case 'user-check':
    case 'autonomy':
      pathContent = (
        <>
          <circle cx="12" cy="12" r="3"></circle>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" strokeLinecap="round" strokeLinejoin="round"></path>
        </>
      );
      break;
    case 'globe':
    default:
      pathContent = (
        <>
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="2" y1="12" x2="22" y2="12" strokeLinecap="round"></line>
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" strokeLinecap="round" strokeLinejoin="round"></path>
        </>
      );
      break;
  }

  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1a1a1a" strokeWidth="1.8" className="highlight-icon me-4 flex-shrink-0 mt-1">
      {pathContent}
    </svg>
  );
}

function Highlights({ project }) {
  const navigate = useNavigate();

  const defaultHighlights = [
    { icon: "globe", text: "Unified multi-brand ecosystem: Led the end-to-end UX for a unified sign-in and account management experience across all Honda and Acura platforms." },
    { icon: "shield", text: "Security Integration: Engineered easy-to-use workflows for Multi-Factor Authentication (MFA), reducing onboarding drop-offs." },
    { icon: "trending-down", text: "Support Ticket Reduction: Decreased authentication-related support tickets by 40% through friendly Recover ID features." }
  ];

  const title = project ? project.title : 'Honda';
  const projectId = project ? project.id : 1;
  const isLocked = project ? project.locked : false;

  const highlights = (project && project.highlights && project.highlights.length > 0)
    ? project.highlights
    : defaultHighlights;

  const handleNavigateToCaseStudy = () => {
    if (isLocked) {
      navigate('/portfolio/locked');
    } else {
      navigate(`/portfolio/${projectId}`);
    }
  };

  return (
    <section id="highlights" className="highlights-section py-5 position-relative">
      <div className="container">
        <div className="row">
          {/* Left Column */}
          <div className="col-lg-5 text-start pe-lg-5 mb-5 mb-lg-0">
            <h1 className="highlights-heading mb-4">Highlights at {title}</h1>
            <p className="highlights-subtext mb-4">
              Designing and shipping enterprise products at scale—backed by measurable impact.
            </p>
            <button 
              className="btn btn-dark rounded-pill px-4 py-2"
              onClick={handleNavigateToCaseStudy}
            >
              View Case Study
            </button>
          </div>
          
          {/* Right Column */}
          <div className="col-lg-7 ps-lg-5 text-start">
            <ul className="highlight-list list-unstyled m-0">
              {highlights.map((item, index) => {
                let textString = '';
                let iconName = 'globe';

                if (typeof item === 'object' && item !== null) {
                  textString = item.text || item.highlight || '';
                  iconName = item.icon || 'globe';
                } else if (typeof item === 'string') {
                  textString = item;
                }

                const colonIndex = textString.indexOf(':');
                let boldPart = '';
                let normalPart = textString;

                if (colonIndex !== -1) {
                  boldPart = textString.substring(0, colonIndex + 1);
                  normalPart = textString.substring(colonIndex + 1);
                }

                return (
                  <li key={index} className="d-flex align-items-start mb-4">
                    {renderHighlightIcon(iconName)}
                    <span className="highlight-text">
                      {boldPart ? <strong>{boldPart}</strong> : null}
                      {normalPart}
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Highlights;
